import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { fwReleaseCopy, fwSignActivityCopy, fwStalledCopy } from '../../utils/constants';

const useStyles = makeStyles({
    menu: {
        marginTop: '2.19rem',
    },
});

export const FwSubmenu = ({ isSubmenu, setIsSubmenu }) => {
    const { menu } = useStyles();
    const history = useHistory();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = path => {
        setAnchorEl(null);
        setIsSubmenu(null);
        history.push(path);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setIsSubmenu(null);
    };

    useEffect(() => {
        setAnchorEl(isSubmenu);
    }, [isSubmenu]);

    return (
        <Menu className={menu} anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
            <MenuItem onClick={() => handleClick('/fw-tasks')}>Zadania</MenuItem>
            <MenuItem onClick={() => handleClick('/fw-files')}>Obsługa plików .bin</MenuItem>
            <MenuItem onClick={() => handleClick('/fw-apns')}>APN</MenuItem>
            <MenuItem onClick={() => handleClick('/fw-logs')}>Logi</MenuItem>
            <MenuItem onClick={() => handleClick('/fw-stalled-pairs')}>{fwStalledCopy.title}</MenuItem>
            <MenuItem onClick={() => handleClick('/fw-release-audit')}>{fwReleaseCopy.title}</MenuItem>
            <MenuItem onClick={() => handleClick('/fw-sign-activity')}>{fwSignActivityCopy.title}</MenuItem>
            <MenuItem onClick={() => handleClick('/fw-config')}>Konfiguracja</MenuItem>
        </Menu>
    );
};

export default FwSubmenu;
